
import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useScroll } from "@/hooks/use-scroll";

export const ScrollToTop = () => {
  const scrolled = useScroll(300); // Show button after scrolling 300px
  const [show, setShow] = useState(false);
  
  // Handle the animation states separately from the actual visibility
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    
    if (scrolled && !show) {
      setShow(true);
    } else if (!scrolled && show) {
      // Add delay for exit animation
      timeout = setTimeout(() => {
        setShow(false);
      }, 300); // Match transition duration
    }
    
    return () => clearTimeout(timeout);
  }, [scrolled, show]);
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  
  if (!show) return null;
  
  return (
    <Button
      onClick={scrollToTop}
      size="icon"
      className={`fixed bottom-24 right-6 z-50 rounded-full shadow-lg ${
        scrolled 
          ? "animate-bounce-up" 
          : "opacity-0 translate-y-10 transition-all duration-300"
      }`}
      aria-label="Scroll to top"
    >
      <ArrowUp className="h-5 w-5" />
    </Button>
  );
};
